<template>
  <div class="section">
    <div class="title-box" v-if="title">
      <div class="title-bg"><span></span></div>
      <div class="title">
        <div class="title-text MF_1">
        <img class="star-a" src="@/assets/images/star-a.svg" alt="star" srcset=""> 
        {{ title }}
        <img class="star-b" src="@/assets/images/star-a.svg" alt="star" srcset="">
        </div>
      </div>
    </div>
    <div class="content">
      <div class="bot-bg"></div>
      <div id="banner">
        <Swiper
          v-if="bannerList.length > 0"
          :modules="[Pagination, Autoplay]"
          :pagination="true"
          :autoplay="enable_carousel ? { delay: carousel_interval || 3000, disableOnInteraction: false } : false"
          class="swiper"
        >
          <SwiperSlide v-for="(image, index) in bannerList" :key="index" @click="goToDetail(image, index)">
            <div class="banner-item">
              <img :src="image.url" :alt="'banner-' + index" />
              <!-- <img src="https://jihuanshe-imagex.jihuanshe.com/pkm/card_versions/CS4bC-085_sc.png" :alt="'banner-' + index" /> -->
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Autoplay } from 'swiper/modules';
import { checkLoginAndGo } from '@/utils/token';
import { track } from '@/utils/tracking';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

declare const jhsapp: any;
interface BannerItem {
  url: string;
  link?: string;
  miniprogram_link?: string;
}

const props = defineProps<{
  bannerList: BannerItem[];
  title: string;
  module_ID: string;
  module_type: string;
  carousel_interval: number;
  enable_carousel: boolean;
}>();


// 跳转详情页
function goToDetail(item: BannerItem, index: number) {
  track('H5Landing_module_operation', {
    operation: 'click_on_banner',
  });

  track('btn_H5Landing_module_banner', {
    module_ID: props.module_ID,
    module_type: props.module_type,
    path: item.link || item.miniprogram_link,
    title_name: props.title,
    index: index,
  });

  checkLoginAndGo(()=>{
    try {
      if (item.link) {
        jhsapp.router(item.link);
      } else  {
        jhsapp.router(item.miniprogram_link);
      }
    } catch (error) {
      console.error('跳转失败:', error);
    }
  })
} 
</script>

<style lang="scss" scoped>
@import '@/styles/section.scss';

#banner {
  width: 100%;
  position: relative;
  
  .swiper {
    width: 100%;
    // height: 148px;
    aspect-ratio: 21/9;
    position: relative;
    overflow: hidden;
    border-radius: var(--corner-8);
  }

  .swiper-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    width: 100%;
    height: 100%;
    cursor: pointer;
    background: #eee;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  :deep(.swiper-pagination) {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    z-index: 1;
  }

  :deep(.swiper-pagination-bullet) {
    width: 8px;
    height: 8px;
    background: var(--container-surface-gray-alpha-subtler);
    opacity: 1;
    margin: 0;
  }
  
  :deep(.swiper-pagination-bullet-active) {
    background: var(--container-surface-dark);
  }
}
</style>
